import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import LiveRoom from '@/views/LiveRoom'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/live',
    name: "liveRoom",
    component: LiveRoom
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
